import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  deleteSchoolHoliday(context, payload) {
    ApiService.setHeader();
    return ApiService.delete("school/holiday/management", {
      params: {
        id: payload,
      },
    }).then((response) => response);
  },
};

export default {
  actions,
};
